import { render, staticRenderFns } from "./LoginPC.vue?vue&type=template&id=51049cf4&scoped=true&"
import script from "./LoginPC.vue?vue&type=script&lang=js&"
export * from "./LoginPC.vue?vue&type=script&lang=js&"
import style0 from "./LoginPC.vue?vue&type=style&index=0&id=51049cf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51049cf4",
  null
  
)

export default component.exports